import { createElement } from 'react';
import { createBrowserRouter, createMemoryRouter } from 'react-router-dom';

import { App } from './App.js';
import { OAuthCallbackRoute, SignedOutRoute } from './live-routes.js';
import type { BillingShellSource } from './product/billing-shells.js';
import {
  AdminRoute,
  CustomerDetailsRoute,
  CustomerRoute,
  NotFoundRoute,
} from './router-components.js';

const baseProductionRoutes = [
  { path: '/', element: createElement(App) },
  { path: '*', element: createElement(NotFoundRoute) },
];

export function createInfraHubRouter(): ReturnType<typeof createBrowserRouter> {
  return createBrowserRouter(baseProductionRoutes);
}

export function createInfraHubLiveRouter(): ReturnType<typeof createBrowserRouter> {
  return createBrowserRouter([
    { path: '/', element: createElement(App) },
    { path: '/auth/callback', element: createElement(OAuthCallbackRoute) },
    { path: '/auth/signed-out', element: createElement(SignedOutRoute) },
    { path: '*', element: createElement(NotFoundRoute) },
  ]);
}

export function createBillingContractOnlyMemoryRouter(input: {
  initialEntry: string;
  source: BillingShellSource;
}): ReturnType<typeof createMemoryRouter> {
  return createMemoryRouter(
    [
      {
        path: '/__contract-only/billing/portal/:customerPortalAccessId',
        element: createElement(CustomerRoute, { source: input.source }),
      },
      {
        path: '/__contract-only/billing/portal/:customerPortalAccessId/details',
        element: createElement(CustomerDetailsRoute, { source: input.source }),
      },
      {
        path: '/__contract-only/billing/portal/:customerPortalAccessId/receivables/:receivableId',
        element: createElement(CustomerDetailsRoute, { source: input.source }),
      },
      {
        path: '/__contract-only/billing/portal/:customerPortalAccessId/payments/:paymentId',
        element: createElement(CustomerDetailsRoute, { source: input.source }),
      },
      {
        path: '/__contract-only/billing/portal/:customerPortalAccessId/invoice-documents/:invoiceDocumentId',
        element: createElement(CustomerDetailsRoute, { source: input.source }),
      },
      {
        path: '/__contract-only/billing/portal/:customerPortalAccessId/payment-complement-documents/:paymentComplementDocumentId',
        element: createElement(CustomerDetailsRoute, { source: input.source }),
      },
      {
        path: '/__contract-only/billing/admin/:tenantId/:customerId',
        element: createElement(AdminRoute, { source: input.source }),
      },
    ],
    { initialEntries: [input.initialEntry] },
  );
}
